import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Crud, CrudService, CustomHttp, ConfigServerService } from '../../../core';
import { Item } from '../item';
import { ItemFilterSearch } from '../filter';
import { ItemSearchAsync } from '../item-search-async';

@Injectable({
    providedIn: 'root'
})
export class ItemCrudHttpService implements Crud<Item> {
    resource = 'item';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private crudService: CrudService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /** Pesquisa todos os itens cadastrados */
    search(): Observable<Item[]> {
        return this.crudService.search<Item>(this.resource);
    }

    searchWithFilter(filter: ItemFilterSearch, drawDatatable: number, offset: number, limit: number, orderBy: number, orderByDir: string): Observable<ItemSearchAsync> {
        // Params
        let params = new HttpParams()
                            .append('drawDatatable', drawDatatable?.toString() ?? null)
                            .append('offset', offset?.toString() ?? null)
                            .append('limit', limit?.toString() ?? null)
                            .append('orderBy', orderBy?.toString() ?? null)
                            .append('orderByDir', orderByDir ? orderByDir : '');
        // Filter params
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<ItemSearchAsync>(this.pathApi, {params});
    }

    /** Procura um único item através do seu ID */
    find(id: number): Observable<Item> {
        return this.crudService.find<Item>(this.resource, id);
    }

    /** Carrega um único item através do seu ID */
    load(id: number): Observable<Item> {
        return this.crudService.load<Item>(this.resource, id)
                    .pipe(
                        map(item => {
                            // Classificações
                            item?.classificacoes?.forEach(classificacao => {
                                // Setando que pode editar a classificação
                                classificacao.canEdit = true;
                            })

                            return item;
                        })
                    );
    }

    /** Insere um novo item */
    insert(entity: Item): Observable<Item> {
        return this.crudService.insert<Item>(this.resource, entity);
    }

    /** Altera um item existente */
    update(entity: Item): Observable<Item> {
        return this.crudService.update<Item>(this.resource, entity);
    }

    /** Exclui um item através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
